import { InteractiveRecipeInstructions } from "./InteractiveRecipeInstructions";
export default InteractiveRecipeInstructions;
